<div class="@container relative h-full w-full min-w-0">
  <div class="flex h-full w-full min-w-0 flex-col gap-4 overflow-auto @xl:grid @xl:grid-cols-2 @xl:overflow-hidden" cdkDropListGroup>
    <!-- AVAILABLE USERS -->
    <div class="flex min-h-0 min-w-0 shrink-0 flex-col overflow-hidden rounded-lg border border-gray-200 bg-gray-50 @xl:flex-1 @xl:shrink">
      <div class="relative flex h-[320px] flex-1 flex-col @xl:h-auto @xl:min-h-0">
        <!-- STICKY HEADER + SEARCH -->
        <div class="z-10 flex shrink-0 flex-col gap-3 bg-gray-50 px-4 pt-3 pb-4">
          <div class="flex items-center justify-between">
            <span class="text-[13px] font-semibold text-gray-500">{{ 'FAVORITE_VIEW.FORM.SUBSCRIBERS.AVAILABLE' | translate }}</span>
            <span class="rounded-md bg-gray-200 px-2 py-0.5 text-[11px] font-bold text-gray-600">{{ availableUsers().length }}</span>
          </div>

          <input
            type="text"
            [(ngModel)]="search"
            [disabled]="usersLoading()"
            [placeholder]="'FAVORITE_VIEW.FORM.SUBSCRIBERS.SEARCH' | translate"
            class="w-full min-w-0 rounded-md border border-gray-200 bg-gray-50 bg-white px-3 py-2 text-[12px] text-gray-600 outline-none placeholder:text-gray-400 hover:border-[#4f79b7] focus:border-[#4f79b7] focus:bg-white focus:ring-1 focus:ring-[#4f79b7] disabled:cursor-not-allowed disabled:border-dashed disabled:bg-gray-50 disabled:text-gray-500"
          />
        </div>

        <!-- LIST -->
        @if (usersLoading()) {
          <iot-platform-ui-card-loader class="absolute inset-0 flex items-center justify-center" />
        } @else if (!availableUsers().length) {
          <span class="pointer-events-none absolute inset-0 flex items-center justify-center p-6 text-xs text-gray-500">
            {{ 'FAVORITE_VIEW.FORM.SUBSCRIBERS.NO_USER_AVAILABLE' | translate }}
          </span>
        }
        <div
          id="available-users-container"
          #availableUsersList="cdkDropList"
          (cdkDropListDropped)="onDropToAvailable($event)"
          [cdkDropListData]="availableUsers()"
          [cdkDropListConnectedTo]="[selectedSubscribersList]"
          class="cdk-drag-drop-container flex flex-1 flex-col gap-2 overflow-y-auto px-4 pb-2 [&_.cdk-drag-drop-element-container]:!rounded-lg [&_.cdk-drag-drop-element-container]:!border [&_.cdk-drag-drop-element-container]:!border-gray-200 [&_.cdk-drag-drop-element-container]:!bg-white [&_.cdk-drag-placeholder]:hidden [&_.dd-action-icon]:!text-[#4f78b7]"
          cdkDropList
          cdkDropListSortingDisabled
        >
          @for (user of availableUsers(); track user.id) {
            <iot-platform-ui-drag-drop-element
              cdkDrag
              [cdkDragData]="user"
              class="[&.cdk-drag-dragging_.cdk-drag-drop-element-container]:!bg-white [&.cdk-drag-preview_.cdk-drag-drop-element-container]:!bg-white"
            >
              <iot-platform-ui-drag-drop-indicator />

              <iot-platform-ui-drag-drop-content class="flex-1">
                <ng-container *ngTemplateOutlet="userCard; context: { $implicit: user }" />
              </iot-platform-ui-drag-drop-content>

              <iot-platform-ui-drag-drop-meta>
                <mat-icon class="dd-action-icon" (click)="onAdd(user)">add</mat-icon>
              </iot-platform-ui-drag-drop-meta>
            </iot-platform-ui-drag-drop-element>
          }
        </div>
      </div>
    </div>

    <!-- SELECTED SUBSCRIBERS -->
    <div
      class="flex min-h-0 min-w-0 shrink-0 flex-col overflow-hidden rounded-lg border border-gray-200 @xl:flex-1 @xl:shrink"
      [class.bg-red-50]="isActive() && !selectedUsers().length"
      [class.bg-gray-50]="!isActive() || !!selectedUsers().length"
    >
      <div class="relative flex h-[320px] flex-1 flex-col @xl:h-auto @xl:min-h-0">
        <!-- STICKY HEADER -->
        <div
          class="z-10 flex shrink-0 items-center justify-between px-4 pt-3 pb-4"
          [class.bg-red-50]="isActive() && !selectedUsers().length"
          [class.bg-gray-50]="!isActive() || !!selectedUsers().length"
        >
          <div class="flex items-center gap-1">
            <span class="text-[13px] font-semibold text-gray-500">{{ 'FAVORITE_VIEW.FORM.SUBSCRIBERS.SELECTED' | translate }}</span>
            @if (isActive() && !selectedUsers().length) {
              <mat-icon
                class="!h-4 !w-4 shrink-0 cursor-pointer !text-[16px] !text-red-500"
                [matTooltip]="'FAVORITE_VIEW.FORM.SUBSCRIBERS.AT_LEAST_ONE_SUBSCRIBER_REQUIRED' | translate"
                matTooltipClass="regular-tooltip"
                matTooltipPosition="above"
                >error_outline</mat-icon
              >
            }
          </div>
          <span class="rounded-md bg-blue-100 px-2 py-0.5 text-[11px] font-bold text-blue-700">{{ selectedUsers().length }}</span>
        </div>

        <!-- LIST -->
        @if (usersLoading()) {
          <iot-platform-ui-card-loader class="absolute inset-0 flex items-center justify-center" />
        } @else if (!selectedUsers().length) {
          <span class="pointer-events-none absolute inset-0 flex items-center justify-center p-6 text-xs text-gray-500">
            {{ 'FAVORITE_VIEW.FORM.SUBSCRIBERS.NO_SUBSCRIBER' | translate }}
          </span>
        }
        <div
          id="selected-subscribers-container"
          #selectedSubscribersList="cdkDropList"
          (cdkDropListDropped)="onDropToSelected($event)"
          [cdkDropListData]="selectedUsers()"
          [cdkDropListConnectedTo]="[availableUsersList]"
          class="cdk-drag-drop-container flex flex-1 flex-col gap-2 overflow-y-auto px-4 pb-3 [&_.cdk-drag-drop-element-container]:!rounded-lg [&_.cdk-drag-drop-element-container]:!border [&_.cdk-drag-drop-element-container]:!border-gray-200 [&_.cdk-drag-drop-element-container]:!bg-white [&_.cdk-drag-placeholder]:hidden [&_.dd-action-icon]:!text-gray-400"
          cdkDropList
          cdkDropListSortingDisabled
        >
          @for (user of selectedUsers(); track user.id) {
            <iot-platform-ui-drag-drop-element
              cdkDrag
              [cdkDragData]="user"
              class="[&.cdk-drag-dragging_.cdk-drag-drop-element-container]:!bg-white [&.cdk-drag-preview_.cdk-drag-drop-element-container]:!bg-white"
            >
              <iot-platform-ui-drag-drop-indicator />

              <iot-platform-ui-drag-drop-content class="flex-1">
                <ng-container *ngTemplateOutlet="userCard; context: { $implicit: user }" />
              </iot-platform-ui-drag-drop-content>

              <iot-platform-ui-drag-drop-meta>
                <mat-icon class="dd-action-icon" (click)="onRemove(user)">close</mat-icon>
              </iot-platform-ui-drag-drop-meta>
            </iot-platform-ui-drag-drop-element>
          }
        </div>
      </div>
    </div>

    <!-- USER CARD -->
    <ng-template #userCard let-user>
      <div class="flex min-w-0 items-center gap-3 p-2">
        <span class="flex size-8 shrink-0 items-center justify-center rounded-full bg-[#dbe6f5] text-[11px] font-bold text-[#4f78b7] uppercase">
          {{ user.firstname?.[0] }}{{ user.lastname?.[0] }}
        </span>
        <div class="flex min-w-0 flex-col">
          <span class="truncate text-[12px] font-semibold text-gray-700">{{ user.firstname }} {{ user.lastname }}</span>
          <span class="truncate text-[11px] text-gray-500">{{ user.email }}</span>
        </div>
      </div>
    </ng-template>
  </div>
</div>
